import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Reveal, MaskedLineOnScroll } from "@/lib/motion";

export default function Finishes() {
  const { t } = useLang();
  return (
    <section id="finishes" data-testid="finishes-section" className="relative py-28 lg:py-40 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
        <div className="lg:col-span-8">
          <Reveal>
            <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.finishes.overline}</span>
          </Reveal>
          <h2 className="mt-6 font-display text-4xl md:text-6xl font-medium tracking-tight text-white leading-none">
            <MaskedLineOnScroll>{t.finishes.title}</MaskedLineOnScroll>
          </h2>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {t.finishes.items.map((f, i) => (
          <Reveal key={f.t} delay={i * 0.08} className="h-full">
            <motion.div
              className="group h-full bg-[#0A0A0A] p-8 lg:p-10 hover:bg-[#111] transition-colors duration-300"
              data-testid={`finish-item-${i}`}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 28 }}
            >
              <div className="flex items-center justify-between">
                <span className="font-accent text-sm text-zinc-600 group-hover:text-[#D4AF37] transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="h-px w-8 bg-white/20 group-hover:w-14 group-hover:bg-[#D4AF37] transition-all duration-500" />
              </div>
              <h3 className="mt-10 font-display text-2xl md:text-3xl text-white">{f.t}</h3>
              <p className="mt-4 text-sm text-zinc-500 leading-relaxed">{f.d}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
